import { z } from 'zod';

import { PrimaryKeySchema } from './utils';

export const EntityTypeSchema = z.enum([
  'PRODUCT',
  'COMPANY',
  'PATENT',
  'CLINICAL_TRIAL',
  'REGULATORY_BODY',
  'PERSON',
  'ORGANIZATION',
  'LOCATION',
  'EVENT',
  'LAW',
  'MONEY',
  'DATE',
  'QUANTITY',
  'OTHER',
  'LANGUAGE',
  'NATIONALITY',
  'NUMBER',
]);

export type EntityType = z.infer<typeof EntityTypeSchema>;

export const EntitySchema = z.object({
  entityId: PrimaryKeySchema,
  entityName: z.string(),
  entityDescription: z.string().nullable(),
  entityType: EntityTypeSchema,
  createdAt: z.coerce.date(),
});

export type Entity = z.infer<typeof EntitySchema>;

export const EntitiesSchema = z.array(EntitySchema);

export type Entities = z.infer<typeof EntitiesSchema>;
